import dateFormat from 'dateformat';
import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Banner, ButtonText, Modal } from '@morressier/alembic';
import { useSubmissionData } from 'src/contexts/SubmissionDataProvider';
import { faBan, faFile } from '@fortawesome/pro-regular-svg-icons';
import ReviewSummaryAccordion from '../../decisionModals/ReviewSummaries';
import { openFile } from 'src/utils/file';

interface Props {
  onClose: () => void;
}

export const EditorialRejectionContextModal = ({ onClose }: Props) => {
  const { rejection: data } = useSubmissionData();

  return (
    <Modal
      isOpen
      closeButtonProps={{
        hidden: true
      }}
      onClose={onClose}
      width="720px"
    >
      <Flex
        padding={8}
        gap={6}
        flexDirection="column"
        maxHeight="80vh"
        overflow="auto"
      >
        <Box>
          <FontAwesomeIcon fontSize={32} icon={faBan} />
        </Box>

        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingGroup">Rejection Context</Text>
        </Flex>
        {!data ? (
          <Banner
            variant="attention"
            heading="No Data Available"
            content="This submission does not have a rejection context data."
          />
        ) : (
          <>
            <Flex gap={2} flexDirection="column">
              <Text textStyle="headingItem">Date Rejected</Text>
              <Text textStyle="textBody">
                {dateFormat(data.dateEntered, 'mmmm d, yyyy')}
              </Text>
            </Flex>

            {data.rejectionReason && (
              <Flex gap={2} flexDirection="column">
                <Text textStyle="headingItem">Rejection Reason </Text>
                <Text textStyle="textBody">{data.rejectionReason}</Text>
              </Flex>
            )}

            {data.editorComment && (
              <Flex gap={2} flexDirection="column">
                <Text textStyle="headingItem">Response to Author </Text>
                <Text textStyle="textBody">{data.editorComment}</Text>
              </Flex>
            )}

            {!!data.attachments?.length && (
              <Box>
                <Text textStyle="headingItem">Attachments</Text>
                <Flex flexDirection="column" marginTop={2} gap={2}>
                  {data.attachments.map(attachment => (
                    <Flex
                      justifyContent="space-between"
                      key={attachment.referenceName}
                    >
                      <Flex gap={2} alignItems="center">
                        <FontAwesomeIcon icon={faFile} />
                        <Text textStyle="textBody">
                          {attachment.referenceName}
                        </Text>
                        <ButtonText onClick={() => openFile(attachment.url)}>
                          View
                        </ButtonText>
                      </Flex>
                    </Flex>
                  ))}
                </Flex>
              </Box>
            )}

            <ReviewSummaryAccordion reviews={data.reviewerFeedback ?? []} />
          </>
        )}

        <Flex
          gap={2}
          justifyContent="flex-end"
          alignItems="center"
          alignSelf="stretch"
        >
          <Button
            onClick={onClose}
            variant="primary"
            type="submit"
            borderRadius="small"
          >
            Close
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
